import { render, staticRenderFns } from "./DatasourceModal.vue?vue&type=template&id=1e19ac1d&scoped=true&"
import script from "./DatasourceModal.vue?vue&type=script&lang=js&"
export * from "./DatasourceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e19ac1d",
  null
  
)

export default component.exports